import { Simplify } from "@jog/types"
import { GroupField, KeyTextField } from "@prismicio/types"

import { typedBoolean } from "../helper"

export type PrebuildBreadcrumbSpecialCategoryFetch = () => Promise<string[]>

export const transBreadcrumbSpecialCategory = (
    categories: GroupField<
        Simplify<{
            category: KeyTextField
        }>
    >
) => [...(categories || [])].map((i) => i.category).filter(typedBoolean)
